import { Box, Typography } from '@iheartjane/reefer';
import type { TerpeneFlavorEnum } from '@iheartjane/types';

import { FlavorCard } from './terpenes/flavorCard';

import styles from './topFlavors.module.css';

interface TopFlavorsProps {
  flavors: {
    count: number;
    value: TerpeneFlavorEnum;
  }[];
}

export const TopFlavors = ({ flavors }: TopFlavorsProps) => {
  return (
    <Box className={styles['topFlavorsContainer']}>
      <Typography variant="body-semibold">Top Flavors</Typography>
      <div className={styles['flavorsScrollContainer']}>
        {flavors.map(({ value }) => (
          <FlavorCard key={value} flavor={value} />
        ))}
      </div>
    </Box>
  );
};
